<div class="global-banner">
  <section
    *ngFor="let message of visibleMessages; trackBy: trackByPath"
    class="global-banner__item"
    [ngClass]="'global-banner__item--' + getVariant(message)"
    [class.global-banner__item--expanded]="message.expanded"
    role="region"
    [attr.aria-label]="message.messageTitle"
  >
    <div class="global-banner__bar">
      <p class="global-banner__heading">
        <span *ngIf="message.messageCatch" class="global-banner__catch">{{ message.messageCatch }}</span>
        <span class="global-banner__title">{{ message.messageTitle }}</span>
      </p>

      <div class="global-banner__controls">
        <button
          *ngIf="message.messageDescription || message.cta"
          type="button"
          class="global-banner__toggle"
          [attr.aria-expanded]="message.expanded"
          [attr.aria-controls]="message.id + '-details'"
          (click)="toggleDetails(message)"
        >
          <span>{{ (message.expanded ? 'globalBanner.showLess' : 'globalBanner.showMore') | translate }}</span>
          <svg
            class="global-banner__chevron"
            [class.global-banner__chevron--up]="message.expanded"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            aria-hidden="true"
            focusable="false"
          >
            <circle cx="7" cy="7" r="7" fill="#ffffff" />
            <path d="M4.5 6L7 8.5L9.5 6" fill="none" stroke="#000000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <button
          *ngIf="message.dismissible"
          #closeButton
          type="button"
          class="global-banner__close"
          [attr.aria-label]="message.messageTitle + ', ' + ('globalBanner.dismiss' | translate)"
          (click)="dismiss(message)"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
            <path d="M1 1L13 13M13 1L1 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>

    <div
      class="global-banner__details"
      [hidden]="!message.expanded"
      [id]="message.id + '-details'"
    >
      <div class="global-banner__paragraph" [innerHTML]="message.messageDescription"></div>

      <a
        *ngIf="message.cta"
        class="global-banner__cta"
        [href]="message.cta.ctaLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ message.cta.ctaLabel }}
        <img class="global-banner__cta-icon" src="./assets/icons/link-share-square.svg" alt="" />
        <span class="sr-only">{{ 'globalBanner.opensNewTab' | translate }}</span>
      </a>
    </div>
  </section>

  <!-- Screen-reader live status. -->
  <!-- Only live region: announces expand/collapse state. -->
  <span class="global-banner__sr-status" role="status" aria-live="polite">{{ statusMessage }}</span>
</div>
